export class Step1 {
	public intitule = 'stepper.form.simp_at.step1';

	public getspan1 = 'form.simp_at.getspan1';
	public idWeb = 'form.simp_at.getidweb';
	public datePublication = 'form.simp_at.getdatepublication';

	constructor() {}
}
